<template>
  <div class="content-wrap">
    <div class="card-header">
      <h3 class="title"></h3>
      <el-button type="primary"
                 @click="handleChapterAdd">添加练习</el-button>
    </div>
    <div class="table-wrap">
      <el-table ref="table"
                :data="results"
                style="width: 100%;"
                row-key="id"
                row-class-name="row-item">
        <el-table-column class-name="title-cell"
                         prop="name"
                         label="练习标题"
                         min-width="300">
          <template slot-scope="scope">
            <input class="input"
                   v-model="scope.row.name"
                   v-focus="scope.row.id == insertId"
                   placeholder="请输入练习标题"
                   @blur="handleTitleChange(scope.row, $event)" />
          </template>
        </el-table-column>
        <el-table-column prop="item_count"
                         label="题数"
                         width="110"
                         align="center">
        </el-table-column>
        <el-table-column prop="item_count"
                         label="关联目录"
                         min-width="240"
                         align="center">
          <template slot-scope="scope">
            <el-select class="select"
                       v-model="scope.row.chapter_id"
                       placeholder="请选择"
                       @change="handleChapterChange($event, scope.row)"
                       style="width: 100%;">
              <el-option v-for="item in chapters"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id"
                         :disabled="item.level == 1">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="status"
                         label="在线状态"
                         width="160"
                         align="center">
          <template v-if="scope.row.level !== 1"
                    slot-scope="scope">
            <el-tag v-if="scope.row.status"
                    type="success">已发布</el-tag>
            <el-tag v-if="!scope.row.status"
                    type="warning">未发布</el-tag>
          </template>
        </el-table-column>
        <el-table-column class-name="action-cell"
                         label="操作"
                         min-width="200"
                         align="center">
          <template slot-scope="scope">
            <div class="menu-wrap">
              <div v-if="scope.row.status == false">
                <el-button type="text"
                           @click="handleStatusChange(scope.row, true)">发布</el-button>
                <el-divider direction="vertical"></el-divider>
              </div>
              <div v-if="scope.row.status">
                <el-button type="text"
                           @click="handleStatusChange(scope.row, false)">下线</el-button>
                <el-divider direction="vertical"></el-divider>
              </div>
              <div>
                <el-button type="text"
                           @click="handlePaperToEdit(scope.row)">编辑试卷</el-button>
                <el-divider direction="vertical"></el-divider>
              </div>
              <div v-if="handleActionCheck(scope.row, 'up')">
                <el-button type="text"
                           @click="handleSortChange(scope.row, 'up')">上移</el-button>
                <el-divider direction="vertical"></el-divider>
              </div>
              <div v-if="handleActionCheck(scope.row, 'down')">
                <el-button type="text"
                           @click="handleSortChange(scope.row, 'down')">下移</el-button>
                <el-divider direction="vertical"></el-divider>
              </div>
              <div>
                <el-button type="text"
                           @click="handleRemovePaper(scope.row)">删除</el-button>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import {
  coursePaperList,
  coursePaperCreate,
  courseChapterList,
  coursePaperUpdate,
  coursePapersUpdate,
  coursePaperDestroy,
} from '@/api/course'

export default {
  data() {
    return {
      insertId: '',
      chapters: [],
      results: [],
    }
  },
  created() {
    this.fetchCoursePaperList()
    this.fetchCourseChapterList()
  },
  methods: {
    // 随堂练习列表请求
    fetchCoursePaperList() {
      coursePaperList({ product_id: this.$route.params.courseId }).then(
        (res) => {
          this.results = res.list || []
        }
      )
    },
    // 课程章节列表请求
    fetchCourseChapterList() {
      courseChapterList({ product_id: this.$route.params.courseId }).then(
        (res) => {
          const list = []
          const temps = res.list || []
          temps.forEach((item) => {
            list.push(item)
            if (item.children && item.children.length) {
              list.push(...item.children)
            }
          })
          this.chapters = list
        }
      )
    },
    // 发布状态变化
    handleStatusChange(row, status) {
      row.status = status
      coursePaperUpdate({ id: row.id, status: row.status ? 1 : 0 })
        .then((res) => {})
        .catch((error) => {
          this.$message.error('在线状态更新异常')
          console.log('error: ', error)
        })
    },
    // 章节关联变化
    handleChapterChange(val, row) {
      coursePaperUpdate({ id: row.id, chapter_id: val })
        .then((res) => {})
        .catch((error) => {
          this.$message.error('章节关联更新异常')
          console.log('error: ', error)
        })
    },
    // 排序位置变化
    handleSortChange(row, sort) {
      let { index, list } = this.computeIndex(row.id)
      let item = list.splice(index, 1)[0]
      if (sort == 'up') {
        list.splice(index - 1, 0, item)
      } else if (sort == 'down') {
        list.splice(index + 1, 0, item)
      }
      const rows = list.map((item, sort) => {
        return { id: item.id, sort: sort }
      })
      coursePapersUpdate(rows)
        .then((res) => {})
        .catch((error) => {
          this.$message.error('练习排序更新异常')
          console.log('error: ', error)
        })
    },
    // 删除章节
    handleRemovePaper(row) {
      coursePaperDestroy({ id: row.id })
        .then((res) => {
          list.splice(index, 1)[0]
        })
        .catch((error) => {
          this.$message.error('练习删除失败')
          console.log('error: ', error)
        })
    },
    // 数据位置计算
    computeIndex(id) {
      let index = null
      let length = 0
      let list = []
      this.results.some((item, i, arr) => {
        if (item.id == id) {
          index = i
          length = this.results.length
          list = arr
          return true
        }
      })
      return { index, length, list }
    },
    // 排序边界检查
    handleActionCheck(row, type) {
      let { index, length } = this.computeIndex(row.id)
      if (type == 'up') {
        if (index === 0) {
          return false
        }
        if (index > 0 && length > 1) {
          return true
        }
      }
      if (type == 'down') {
        if (index === length - 1) {
          return false
        }
        return true
      }
      return false
    },
    // 章节标题变化
    handleTitleChange(row) {
      coursePaperUpdate({ id: row.id, name: row.name })
        .then((res) => {
          this.insertId = ''
        })
        .catch((error) => {
          this.$message.error('章节标题更新异常')
          console.log('error: ', error)
        })
    },
    // 章节试卷编辑
    handlePaperToEdit(row) {
      this.$router.push(
        `/course/detail/${this.$route.params.courseId}/paper/${row.paper_id}`
      )
    },
    // 添加章
    handleChapterAdd() {
      let newPaper = {
        product_id: this.$route.params.courseId,
        name: '',
        sort: this.results.length,
        status: 0,
      }
      coursePaperCreate(newPaper)
        .then((res) => {
          this.insertId = res.id
          this.results.push(res)
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
    // table row 展开状态变化
    hendleToggleExpand(row, expanded = true) {
      this.$refs.table.toggleRowExpansion(row, expanded)
    },
  },
  directives: {
    focus: {
      // 指令的定义
      inserted: function (el, { value }) {
        if (value) {
          el.focus()
        }
      },
      update: function (el, { value }) {
        if (value) {
          el.focus()
        }
      },
    },
  },
}
</script>

<style scoped lang="less">
.content-wrap {
  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
  }

  .table-wrap {
    /deep/ .title-cell {
      .cell {
        display: flex;
        align-items: center;
      }
      .input {
        width: 250px;
        height: 32px;
        line-height: 32px;
        background: transparent;
        border: 1px solid transparent;
        border-radius: 4px;
        color: #606266;
        padding: 0 15px;
        outline: 0;

        &:focus {
          background: #fff;
          border-color: #409eff !important;
        }
      }

      &:hover .input {
        background: #fff;
        border-color: #dcdfe6;
      }
    }
    /deep/ .action-cell {
      .el-divider--vertical {
        margin: 0 4px;
      }
    }

    /deep/ .row-item {
      .menu-wrap {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .select {
        input {
          text-align: center;
          border-color: transparent;
        }
        &:hover input {
          border-color: #dcdfe6;
        }
      }
    }
  }
}
</style>
